import Tree from './components/Tree';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'tree',
  pluginComponent: Tree,
});
